import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { APP_CONFIG, AppConfig } from '../../../../../config/app-config.interface';
import { HomeNewsComponent as BaseComponent } from '../../../../../app/home-page/home-news/home-news.component';

@Component({
  selector: 'ds-home-news',
  styleUrls: ['./home-news.component.scss'],
  templateUrl: './home-news.component.html',
})
export class HomeNewsComponent extends BaseComponent implements OnInit {
  itemCount$: Observable<string> = of('—');
  communityCount$: Observable<string> = of('—');
  collectionCount$: Observable<string> = of('—');

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private appConfig: AppConfig,
  ) {
    super();
  }

  ngOnInit(): void {
    const api = (this.appConfig.rest.baseUrl ?? '') + '/api';

    this.itemCount$ = this.http
      .get<any>(`${api}/discover/search/objects?query=*&dsoType=item&page=0&size=1`)
      .pipe(
        map(r => this.fmt(r?._embedded?.searchResult?.page?.totalElements)),
        catchError(() => of('—')),
      );

    this.communityCount$ = this.http
      .get<any>(`${api}/core/communities?page=0&size=1`)
      .pipe(
        map(r => this.fmt(r?.page?.totalElements)),
        catchError(() => of('—')),
      );

    this.collectionCount$ = this.http
      .get<any>(`${api}/core/collections?page=0&size=1`)
      .pipe(
        map(r => this.fmt(r?.page?.totalElements)),
        catchError(() => of('—')),
      );
  }

  private fmt(n: number | null | undefined): string {
    if (n == null) return '—';
    return n >= 1000 ? (n / 1000).toFixed(1) + 'K' : String(n);
  }
}
